Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.INTEGER = (function () {

    function INTEGER (field, entity) {

        Greenmile.PanelBuilder.Fields.ComplexField.apply(this, arguments);

    };

    return INTEGER;

}());